import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/brand/gtr-evolution-logo-color-on-dark.svg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-9 col-lg-8 col-xl-6" }
const _hoisted_3 = { class: "card auth-form-card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-text" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["type"]
const _hoisted_10 = {
  key: 0,
  id: "capslock-on",
  class: "ms-2 text-warning small"
}
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fa-sharp fa-solid fa-spinner fa-spin"
}
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = { class: "mt-2 px-2 text-muted small text-center" }
const _hoisted_16 = {
  class: "modal fade",
  id: "change-password-modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "ChangePasswordModalLabel",
  "aria-hidden": "true",
  ref: "resetPasswordModal"
}
const _hoisted_17 = { class: "modal-dialog -modal-dialog-centered" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header bg-secondary py-2 bg-gradient text-light" }
const _hoisted_20 = {
  type: "button",
  class: "btn-close btn-sm btn-close-white",
  "aria-label": "Close",
  ref: "close",
  "data-bs-dismiss": "modal"
}
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = { novalidate: "" }
const _hoisted_23 = { class: "form-floating mb-3" }
const _hoisted_24 = {
  key: 0,
  class: "text-warning small"
}
const _hoisted_25 = {
  key: 1,
  class: "text-danger small"
}
const _hoisted_26 = { class: "modal-footer justify-content-center" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "fa-sharp fa-solid fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_modal = _resolveComponent("error-modal")!
  const _component_information_modal = _resolveComponent("information-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          role: "form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "auth-hero-slogan text-center" }, [
            _createTextVNode(" ¡Bienvenido a tu historia de "),
            _createElementVNode("span", { class: "text-gradient-gtr" }, "éxito"),
            _createTextVNode("! ")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-center auth-brand-wrap" }, [
                _createElementVNode("img", {
                  class: "auth-brand-logo",
                  src: _imports_0,
                  alt: "GTR Evolution"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", { class: "fa-sharp fa-solid fa-id-card-alt fa-fw" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Correo electrónico / Nombre de Usuario",
                    "aria-label": "Correo electrónico o Nombre de Usuario",
                    id: "username",
                    ref: "username",
                    autocomplete: "username",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.userId) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.loginForm.userId,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa-sharp fa-solid fa-lock fa-fw" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showPassword ? 'text' : 'password',
                      class: "form-control",
                      placeholder: "Contraseña",
                      "aria-label": "Contraseña",
                      id: "password",
                      ref: "password",
                      autocomplete: "current-password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event))
                    }, null, 8, _hoisted_9), [
                      [
                        _vModelDynamic,
                        _ctx.loginForm.password,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-secondary pt-1",
                      type: "button",
                      id: "show-password",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-sharp fa-solid fa-xs fa-fw", _ctx.showPassword ? 'fa-eye-slash' : 'fa-eye'])
                      }, null, 2)
                    ])
                  ]),
                  (_ctx.capsLockOn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("span", { class: "small" }, [
                          _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-1" }),
                          _createTextVNode(" BloqMayús (CapsLock) está activado. ")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.login())),
                    class: "btn btn-primary my-4 w-100",
                    disabled: 
                    !_ctx.loginForm.userId || !_ctx.loginForm.password || _ctx.loading
                  
                  }, [
                    _cache[13] || (_cache[13] = _createTextVNode(" Ingresar ", -1)),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_12)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showResetPasswordModal()))
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "fa-sharp fa-solid fa-key" }, null, -1),
                    _createTextVNode(" ¿Olvidaste tu contraseña? ", -1)
                  ]))])
                ])
              ])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary d-none",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confetti()))
    }, "Test confetti"),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "fa-sharp fa-solid fa-key fa-fw me-2" }),
              _createTextVNode(" Recuperación de Contraseña ")
            ], -1)),
            _createElementVNode("button", _hoisted_20, null, 512)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("form", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control mb-1",
                  id: "userEmail",
                  placeholder: "Correo electrónico (E-mail)",
                  onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validateEmailInput && _ctx.validateEmailInput(...args))),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userEmail) = $event))
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.userEmail,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("label", { for: "userEmail" }, "Correo Electrónico (E-mail)", -1)),
                (_ctx.emailValidation.hasWarning)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-circle fa-fw mx-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.emailValidation.hasError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw mx-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[22] || (_cache[22] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary mx-3",
              "data-bs-dismiss": "modal"
            }, " Cancelar ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary mx-3",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetPassword(_ctx.userEmail))),
              disabled: 
              _ctx.emailValidation.hasError || _ctx.userEmail === '' || _ctx.loadingPW
            
            }, [
              _cache[21] || (_cache[21] = _createTextVNode(" Enviar liga de restablecimiento ", -1)),
              (_ctx.loadingPW)
                ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                : _createCommentVNode("", true)
            ], 8, _hoisted_27)
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_error_modal, {
      title: _ctx.errorTitle,
      message: _ctx.errorMessage
    }, null, 8, ["title", "message"]),
    _createVNode(_component_information_modal, {
      title: _ctx.informationTitle,
      message: _ctx.informationMessage
    }, null, 8, ["title", "message"])
  ], 64))
}